<div class="sh-form-tag-list">
  <div class="sh-form-tag-list__input">
    <ng-container *ngTemplateOutlet="inputField"></ng-container>
  </div>
  <ng-container *ngTemplateOutlet="tagList"></ng-container>
  <ng-container *ngTemplateOutlet="errorMessages"></ng-container>
</div>

<ng-template #inputField>
  <div class="sh-input-field-with-action">
    <div class="sh-input-field-with-action__input">
      <med-webservice-search
        [searchControl]="webserviceSearchControl"
        [webserviceConfig]="webserviceConfig"
        [clearOnSelect]="multiple"
        [indeterminateMsg]="'general.different-values' | translate"
        [disabledMsg]="disabledMsg"
        (selected)="onLookupSelection($event)"
      ></med-webservice-search>
    </div>
    @if (searchActionItem$ | async; as searchActionItem) {
      <sh-action-item class="sh-input-field-with-action__action" [item]="searchActionItem">
      </sh-action-item>
    }
  </div>
</ng-template>

<ng-template #tagList>
  @if ((tags$ | async)?.options.length > 0) {
    <ul [id]="id + '-list'" class="sh-tag-list sh-form-tag-list__list">
      @if (multiple) {
        @for (tag of (tags$ | async)?.options; track tag; let i = $index) {
          <li
            [id]="id + '-list-tag-' + i"
            class="sh-tag sh-tag-list__item -sh-truncate"
            [title]="tag.label"
            [class.sh-tag--readonly]="disabled"
            >
            <span class="sh-tag__label">{{ tag.label }}</span>
            @if (!disabled) {
              <button
                [id]="id + '-list-tag-' + i + '-remove-action'"
                type="button"
                class="sh-tag__button"
                (click)="removeValue(tag.value)"
                >
                <svg sh-icon [name]="'delete'" [size]="sizes.SMALL" [addDefaultClasses]="false" aria-hidden="true" class="sh-tag__icon"></svg>
              </button>
            }
          </li>
        }
      }
    </ul>
  } @else {
    <p class="sh-clear-margin">{{ placeholderMsg }}</p>
  }
</ng-template>

<ng-template #errorMessages>
  @if ((isIndeterminate$ | async) && multiple) {
    <p class="sh-form-group__feedback">{{ indeterminateMsg }}</p>
  }
</ng-template>

